import { render } from "./RestaurantNameForm.vue?vue&type=template&id=7efd2247&ts=true"
import script from "./RestaurantNameForm.vue?vue&type=script&lang=ts"
export * from "./RestaurantNameForm.vue?vue&type=script&lang=ts"

import "./RestaurantNameForm.vue?vue&type=style&index=0&id=7efd2247&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.35_vue@3.5.38_typescript@5.9.3__webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__